/**
 * NewAnalysisPage — the source-agnostic "New analysis" entry point.
 *
 * The dataset-centric Home's "New analysis" CTA lands here. Unlike
 * DatabricksImportPage (which pins the form to Databricks), this hosts
 * JourneyCreationForm WITHOUT `forceDataSource`, so its built-in segmented
 * toggle (File Upload | Databricks) is shown and the user picks the source.
 * The form defaults to File Upload, so an upload is the zero-click-deeper path —
 * which is the gap this page closes (Home previously forced everyone through the
 * Databricks-only page to start any analysis).
 *
 * All create/analyze logic stays in JourneyCreationForm — this page is chrome.
 * `/import/databricks` is kept as the Integrations-specific deep link.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { JourneyCreationForm } from '../../components/JourneyCreationForm';
import './databricks-import.css';

export const NewAnalysisPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="dbx-import-page">
      <div className="dbx-import-inner">
        <button
          type="button"
          className="dbx-import-back"
          onClick={() => navigate('/home')}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Home
        </button>

        <div className="dbx-import-eyebrow">New analysis</div>
        <h1 className="dbx-import-headline">Analyze your data</h1>
        <p className="dbx-import-subhead">
          Upload a file, or import a Databricks Unity Catalog table — pick the
          source below, name the analysis, and run it.
        </p>

        <JourneyCreationForm
          isOpen
          variant="page"
          onClose={() => navigate('/home')}
          onSuccess={(groupId) => navigate(`/journey/${groupId}`)}
        />
      </div>
    </div>
  );
};

export default NewAnalysisPage;
